var map = {
	"./ambulance.png": 1219,
	"./bed.png": 1220,
	"./bicycle.png": 1221,
	"./boy.png": 1222,
	"./bulldozer.png": 1223,
	"./bus.png": 1224,
	"./car.png": 1225,
	"./cement-mixer.png": 1226,
	"./crane.png": 1227,
	"./excavator.png": 1228,
	"./female.png": 1229,
	"./forklift.png": 1230,
	"./galley-cart.png": 1231,
	"./girl.png": 1232,
	"./helmet.png": 1233,
	"./infant.png": 1234,
	"./lorry.png": 1235,
	"./male.png": 1236,
	"./mini-bus.png": 1237,
	"./motorcycle.png": 1238,
	"./pmd.png": 1239,
	"./police-car.png": 1240,
	"./prime-mover.png": 1241,
	"./scooter.png": 1242,
	"./seatbelt.png": 1243,
	"./ship.png": 1244,
	"./storage-bin.png": 1245,
	"./tanker.png": 1246,
	"./tractor.png": 1247,
	"./trailer.png": 1248,
	"./tram.png": 1249,
	"./van.png": 1250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1218;